var ezdia;
(function (ezdia) {
    var notification = function (context) {
        var timestamp = context.timestamp, list = context.list;
        var ret = "<p>We have detected unsaved changes to this item <strong> " + timestamp + "</strong>. Please review the each field and decide whether you would like to restore or discard the changes</p>\n    <ol>" + list
            .map(function (obj) {
            var label = obj.label, value = obj.value;
            return "<li>" + label + " - <span title=\"Last modified on: " + value.timestamp + "\">" + value.timestamp + "</span></li>";
        })
            .join('') + "\n    </ol>";
        return ret;
    };
    var review = function (context) {
        var currentVal = context.currentVal, displayVal = context.displayVal, edittype = context.edittype, timestamp = context.timestamp;
        var ret = "";
        if (edittype === 'html') {
            ret = "<div class=\"row localsave-data-review\">\n        <div class=\"col-md-6\"><iframe id=\"local-save-review-old-frm\" width=\"100%\" height=\"100%\"></iframe></div>\n        <div class=\"col-md-6\" style=\"border-left: 1px solid #CCC;\"><iframe id=\"local-save-review-new-frm\" width=\"100%\" height=\"100%\"></iframe></div>\n      </div>";
        }
        else {
            ret = "<dl class=\"localsave-data-review\">\n        <dt>Last modified on:</dt>\n        <dd>" + timestamp + "</dd>\n        <dt>Local copy:</dt>\n        <dd>" + displayVal + "</dd>\n        <dt>Copy on server:</dt>\n        <dd>" + currentVal + "</dd>\n      </dl>";
        }
        return ret;
    };
    var templates;
    (function (templates) {
        templates.localStorage = {
            notification: notification,
            review: review
        };
    })(templates = ezdia.templates || (ezdia.templates = {}));
})(ezdia || (ezdia = {}));
